// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MemberNewQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type MemberNewQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationRoles: Array<{
    __typename?: "OrganizationRole";
    id: string;
    name: string;
    updatedAt: number;
  }>;
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    name: string;
  } | null;
};

export const MemberNewDocument = gql`
  query MemberNew($organizationSlug: ID!) {
    getOrganizationRoles(organizationSlug: $organizationSlug) {
      id
      name
      updatedAt
    }
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      name
    }
  }
`;

/**
 * __useMemberNewQuery__
 *
 * To run a query within a React component, call `useMemberNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberNewQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useMemberNewQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberNewQuery,
    MemberNewQueryVariables
  > &
    (
      | { variables: MemberNewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberNewQuery, MemberNewQueryVariables>(
    MemberNewDocument,
    options,
  );
}
export function useMemberNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberNewQuery,
    MemberNewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberNewQuery, MemberNewQueryVariables>(
    MemberNewDocument,
    options,
  );
}
// @ts-ignore
export function useMemberNewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemberNewQuery,
    MemberNewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MemberNewQuery, MemberNewQueryVariables>;
export function useMemberNewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberNewQuery, MemberNewQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MemberNewQuery | undefined,
  MemberNewQueryVariables
>;
export function useMemberNewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberNewQuery, MemberNewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberNewQuery, MemberNewQueryVariables>(
    MemberNewDocument,
    options,
  );
}
export type MemberNewQueryHookResult = ReturnType<typeof useMemberNewQuery>;
export type MemberNewLazyQueryHookResult = ReturnType<
  typeof useMemberNewLazyQuery
>;
export type MemberNewSuspenseQueryHookResult = ReturnType<
  typeof useMemberNewSuspenseQuery
>;
export type MemberNewQueryResult = Apollo.QueryResult<
  MemberNewQuery,
  MemberNewQueryVariables
>;
